import { inject } from '@angular/core';
import type { CanActivateChildFn } from '@angular/router';
import { Router } from '@angular/router';
import { RcrExchangeNavigationServiceService } from '../services/rcr-exchange-navigation-service.service';

export const TakedownRouteGuard: CanActivateChildFn = (route, state) => {
  const rcrNavigationService = inject(RcrExchangeNavigationServiceService);
  const router = inject(Router);

  if (state.url === '/rcr-exchange/rcr-takedown') {
    return true;
  }

  if (rcrNavigationService.canNavigate == null || rcrNavigationService.canNavigate === undefined) {
    router.navigate(['/rcr-exchange/rcr-takedown']);
    return true;
  }

  return rcrNavigationService.canNavigate ? true : false;
};
